import { useState, ChangeEvent } from "react";

function useFormData<T extends Record<string, any>>(initialState: T) {
  const [formData, setFormData] = useState<T>(initialState);
  const handleChange = (
    e:
      | ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
      | { id: keyof T; value: any }
  ): void => {
    if ("target" in e) {
      // For native inputs
      const { id, value } = e.target;
      setFormData((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    } else {
      // For custom inputs like RadioGroup
      const { id, value } = e;
      setFormData((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    }
  };

  const resetForm = (): void => {
    setFormData(initialState);
  };

  return {
    formData,
    handleChange,
    resetForm,
    setFormData,
  };
}

export default useFormData;
